require('./prtv-interface-1.scss');
import EmetteurtntRepository from '../../../../repositories/emetteurtnt.repository';
import {CHAINES_LOCALES_RECUES} from '../../../../utils/constantes.util.js';

import DemandeActions from '../../../../actions/demande.actions';
import MultiplexActions from '../../../../actions/multiplex.actions';

import { OUI_NON, OUI_NON_NSP } from '../../../common/model';
import { TYPE_PERTURBATEUR } from '../../model';
import { STEPS } from '../../../../utils/routes.util';
import { CIVILITE } from '../../../base/model';
import assign from 'lodash/assign';
import filter from 'lodash/filter';
import forEach from 'lodash/forEach';
import some from 'lodash/some';
import map from 'lodash/map';
import flattenDeep from 'lodash/flattenDeep';
import uniqBy from 'lodash/uniqBy';
import remove from 'lodash/remove';
import includes from 'lodash/includes';
import { EMAIL_PATTERN, TELEPHONE_PATTERN } from '../../../../utils/pattern.util';

export default class PrtvInterface1Component {
  constructor() {
    this.controller = PrtvInterface1Controller;
    this.template = require('./prtv-interface-1.html');
  }
}

// @ngInject
class PrtvInterface1Controller {

  constructor($scope, $ngRedux) {
    this.CIVILITE = CIVILITE;
    this.OUI_NON = OUI_NON;
    this.OUI_NON_NSP = OUI_NON_NSP;
    this.TYPE_PERTURBATEUR = TYPE_PERTURBATEUR;
    this.suspicionLteCalled = false;
    this.data = {chaines: []};
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.chainesCode = {};
    this.muxExclus = ['R15', 'ROM1', 'ROML', 'ROM2'];
    this.suspicionLte = {
      loading: false,
      message: ''
    };
    this.regex = new RegExp(/^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/, 'u');
    this.emailPattern = EMAIL_PATTERN;
    this.telephonePattern = TELEPHONE_PATTERN;

  }

  $onInit() {
    // Demande de récupération de la demande avant connexion au state
    this.$ngRedux.dispatch(DemandeActions.loadDemande(STEPS.PRTV_INTERFACE_1));
    this.$ngRedux.dispatch(MultiplexActions.loadData());
    this.suspicionLteCalled = false;
    this.isAdresseDomCom = false;

    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: state.demande.data.prtvInterface1 ? state.demande.data.prtvInterface1.asMutable({deep: true}) : this.data,
          //On vérifie si on a déjà récupérer la liste des mux sinon on les reload
          multiplex: (state.demande.data.accueilInterface2 && state.demande.data.accueilInterface2.multiplex) ?
                      state.demande.data.accueilInterface2.multiplex : (state.multiplex.data ? state.multiplex.data.data : state.multiplex.data),
          adresse: (state.demande.data.accueilInterface2 && state.demande.data.accueilInterface2.adresse) ?
                      state.demande.data.accueilInterface2.adresse : null,
          typePersonne: state.demande.data.typePersonne
        };
      }
    )((selectedState) => {
          assign(this, selectedState);
          if (!this.data.chaines) {
            this.data.chaines = [];
          }
          this.handleChainesLoaded();
          this.data.allChaines = this.computeChaines();
          // pour appeler une seule fois le flagLte
          if (!this.suspicionLteCalled) {
            this.flagLte();
          }
          if (this.adresse) {
            // Est-ce que l'adresse concerne un DOM / COM ?
            this.isAdresseDomCom = ['97','98'].indexOf(this.adresse.commune.insee.substr(0, 2)) !== -1;
          }
        });
    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
  }

  handleChainesLoaded() {
    if (this.fetching) {
      return;
    }
    if (!this.data.chaines.length || !this.multiplex.length) {
      return;
    }
    this.data.chaines = filter(this.data.chaines, chaine => some(this.multiplex, (m) => some(m.chainesActives, (c) => c.id === chaine.id)));
    forEach(this.data.chaines, (chaine) => {
      this.chainesCode[chaine.id] = true;
    });
    if (this.data.infoChaineLocal === CHAINES_LOCALES_RECUES) {
      this.chainesCode[0] = true;
    }
  }

  onTypePerturbationChange(typePerturbation) {
    this.data.typePerturbation = typePerturbation;
  }

  flagLte() {
    if (this.adresse === null) {
      return;
    }
    this.suspicionLte.loading = true;
    this.suspicionLteCalled = true;
    if (!this.adresse.numero) {
      this.suspicionLte = EmetteurtntRepository.searchSuspicionLte(this.adresse.voie, this.adresse.codePostal.codepostal, this.adresse.commune.nom)
        .then((response) => {
                this.suspicionLte.message = response.message;
              }).finally(() => this.suspicionLte.loading = false);
    } else {
      this.suspicionLte = EmetteurtntRepository.searchSuspicionLte(this.adresse.numero + ' ' + this.adresse.voie,
       this.adresse.codePostal.codepostal, this.adresse.commune.nom)
        .then((response) => {
          this.suspicionLte.message = response.message;
        }).finally(() => this.suspicionLte.loading = false);
    }
  }
  computeChaines() {
    if (this.multiplex === null) {
      return [];
    }
    //on exclue les multiplex de domtom
    this.multiplex = filter(this.multiplex, m=> !includes(this.muxExclus, m.code));
    //on exclue les chaines locales
    return remove(uniqBy(flattenDeep(map(this.multiplex, (m) =>m.chainesActives)), d => d.id), c => c.code !== '30-39');
  }

  onChangeSelected(chaine) {
    if (chaine) {
      if (this.chainesCode[chaine.id]) {
        // Sélection de la chaîne
        this.data.chaines.push(chaine);
      } else {
        // Déselection de la chaîne
        this.data.chaines = filter(this.data.chaines, (c) => c.id !== chaine.id);
      }
    } else {
      if (this.chainesCode[0]) {
        this.data.infoChaineLocal = CHAINES_LOCALES_RECUES;
      } else {
        this.data.infoChaineLocal = '';
      }
    }
  }

  // Actions
  prevStep() {
    this.$ngRedux.dispatch(DemandeActions.updatePrtvInterface1(this.data, true));
  }
  nextStep() {
    this.data.demandeEnquetePapier = true;
    this.data.isAdresseDomCom = this.isAdresseDomCom;
    if (this.data.stationLteConfirmee === 'OUI' || this.suspicionLte.message !== '0') {
      this.data.demandeEnquetePapier = false;
    }
    this.$ngRedux.dispatch(DemandeActions.updatePrtvInterface1(this.data));
  }
}



// WEBPACK FOOTER //
// ./src/modules/prtv/components/prtv-interface-1/prtv-interface-1.component.js